import React from 'react';
import { FadeIn } from './FadeIn';
export function PainStories() {
  const pains = [{
    num: '01',
    title: 'El esfuerzo sin resultado visible',
    text: 'Llevás meses entrenando duro. Vas casi todos los días. Pero cuando te mirás al espejo o intentás correr más rápido, los cambios no están a la altura del sacrificio. No es que no entrenás. Es que no entrenás con sistema.'
  }, {
    num: '02',
    title: 'La pregunta que te incomoda',
    text: 'Alguien te pregunta qué estás trabajando. Le contás. Pero en el fondo sabés que no hay una lógica clara detrás. No hay progresión pensada. No hay bloques. No hay periodización. Hay esfuerzo sin dirección.'
  }, {
    num: '03',
    title: 'La sesión sin propósito real',
    text: 'Llegás al gimnasio con una idea general de qué trabajar. Hacés lo que se siente bien. La sesión "sale bien" pero sin saber si hoy te acercaste a tu objetivo o simplemente te cansaste. Sin datos. Sin registro.'
  }, {
    num: '04',
    title: 'El plan que abandonás',
    text: 'Compraste planes. Seguiste rutinas. Empezaste fuerte y a las 3 semanas perdiste el hilo. No porque seas inconstante. Sino porque ningún plan te dio la estructura mental y el sistema de adherencia para sostenerlo.'
  }];
  return <section className="py-20 sm:py-32 px-4 bg-carbon-900 border-t border-carbon-800" data-id="element-105">
      <div className="max-w-5xl mx-auto" data-id="element-106">
        <FadeIn data-id="element-107">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-display text-white mb-16 uppercase tracking-wide text-center" data-id="element-108">
            Y mientras tanto, <br className="hidden sm:block" data-id="element-109" />
            <span className="text-carbon-400" data-id="element-110">
              pasan cosas que frenan todo.
            </span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-111">
          {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-112">
              <div className="bg-carbon-950 border border-carbon-800 rounded-3xl p-8 sm:p-10 h-full group hover:bg-carbon-900 transition-colors relative overflow-hidden" data-id="element-113">
                <div className="absolute top-0 left-0 w-full h-1 bg-electric scale-x-0 group-hover:scale-x-100 transition-transform origin-left" data-id="element-114" />
                <span className="font-mono text-electric text-sm tracking-widest mb-4 block" data-id="element-115">
                  Falla {pain.num}
                </span>
                <h3 className="text-2xl font-display text-white mb-4 uppercase tracking-wide" data-id="element-116">
                  {pain.title}
                </h3>
                <p className="text-carbon-300 font-sans leading-relaxed" data-id="element-117">
                  {pain.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}